// // components/DashboardCard.jsx
// import { Card, CardContent, Typography } from "@mui/material";

// const DashboardCard = ({ title, value }) => {
//   return (
//     <Card
//       sx={{
//         // m: 1,
//         minWidth: 200,
//         borderRadius: 1.5,
//         boxShadow: "0 4px 12px rgba(0, 0, 0, 0.09)",
//       }}
//     >
//       <CardContent>
//         <Typography variant="h5">{title}</Typography>
//         <Typography variant="h4" color="primary">
//           {value}
//         </Typography>
//       </CardContent>
//     </Card>
//   );
// };

// export default DashboardCard;
import { Card, Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const DashboardCard = ({ title, value, icon, color = "#6366F1", onClick }) => {
  return (
    <Card
      onClick={onClick}
      elevation={0}
      sx={{
        height: 150,
        borderRadius: "16px",
        cursor: onClick ? "pointer" : "default",

        /* SOFT HRMS SURFACE */
        background: `
          radial-gradient(circle at 0% 0%, ${alpha(color, 0.18)} 0%, transparent 45%),
          radial-gradient(circle at 100% 0%, ${alpha(color, 0.12)} 0%, transparent 45%),
          radial-gradient(circle at 0% 100%, ${alpha(color, 0.1)} 0%, transparent 50%),
          radial-gradient(circle at 100% 100%, ${alpha(color, 0.14)} 0%, transparent 50%),
          #ffffff
        `,

        /* CLEAR SEPARATION FROM PAGE */
        border: "1.5px solid #9cc4cc",

        /* VERY SUBTLE SHADOW (NOT FLOATING) */
        boxShadow: "0 2px 8px rgba(16,24,40,0.05)",

        /* CLEAN GRID ALIGNMENT */
        display: "grid",
        gridTemplateColumns: "70px 1fr",
        alignItems: "center",
        px: 2.5,
      }}
    >
      {/* ICON BADGE */}
      <Box
        sx={{
          width: 52,
          height: 52,
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          background: alpha(color, 0.14),
          color: color,

          /* subtle inner depth */
          border: `1px solid ${alpha(color, 0.25)}`,

          "& svg": {
            fontSize: 28,
          },
        }}
      >
        {icon}
      </Box>

      {/* TEXT AREA */}
      <Box
        sx={{
          pl: 1.5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 500,
            color: "#667085",
            letterSpacing: ".2px",
            mb: 0.5,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: 30,
            fontWeight: 500,
            color: "#101828",
            lineHeight: 1.1,
          }}
        >
          {value ?? 0}
        </Typography>
      </Box>
    </Card>
  );
};

export default DashboardCard;
